import { useGoogleLogin } from '@react-oauth/google';
import React, { useEffect, useRef, useState } from 'react';
import Axios from '../../../v2/services/Axios';
import { addMinutes, mergeDateTime } from '../../../common/helpers/helper';

const AddEventToCalendar = ({ selectedAppointment, docData, setErrorMessage, setSuccessMessage, appointmentId, showUpdateCalendarBtn, updatedData, appointment, autoTrigger = false }) => {
    
    const [appointmentAdded, setAppointmentAdded] = useState(false);
    const [accessToken, setAccesssToken] = useState("")
    const [isWebAuthed, setIsWebAuthed] = useState(null)
    const [isLoading, setIsLoading] = useState(false);
    const [showPopupBlockedFallback, setShowPopupBlockedFallback] = useState(false);
    const autoTriggeredRef = useRef(false);
    const lastLoginTriggerSourceRef = useRef('manual');

    // const login = useGoogleLogin({
    //     scope: 'https://www.googleapis.com/auth/calendar.events',
    //     onSuccess: (codeResponse) => {
    //         console.log("access token", codeResponse?.access_token)
    //         setAccesssToken(codeResponse?.access_token)
    //     },
    //     onError: (error) => {
    //         setAccesssToken("")
    //         console.log("google auth error", error)
    //     }
    // });
    // const login = useGoogleLogin({
    //     scope: 'https://www.googleapis.com/auth/calendar.events',
    //     onSuccess: (codeResponse) => {
    //         console.log("access token", codeResponse);
    //         setAccesssToken(codeResponse?.access_token);
    //     },
    //     onError: (error) => {
    //         setAccesssToken("");
    //         console.log("google auth error", error);
    //     },
    //     accessType: 'offline', // Request a refresh token
    //     prompt: 'consent', // Force the consent screen to ensure a refresh token is generated
    // });

    const login = useGoogleLogin({
        scope: 'https://www.googleapis.com/auth/calendar.events',
        onSuccess: (codeResponse) => {
            setShowPopupBlockedFallback(false);
            setAccesssToken(codeResponse.code)
        },
        onError: (error) => {
            console.log("Google auth error", error);
            if (lastLoginTriggerSourceRef.current === 'auto') {
                setShowPopupBlockedFallback(true);
            }
        },
        flow: 'auth-code', 
        accessType: 'offline', 
        // prompt: 'consent', 
    });



    const createGoogleEvent = async (code = null) => {
        try {
            const payload = {
                title: `Appointment with Dr ${docData?.fullName}`,
                start_date: mergeDateTime(selectedAppointment?.date || selectedAppointment?.appointmentDate, selectedAppointment?.appTime || selectedAppointment?.appointmentTime),
                end_date: addMinutes(mergeDateTime(selectedAppointment?.date || selectedAppointment?.appointmentDate, selectedAppointment?.appTime || selectedAppointment?.appointmentTime), 30),
                idAppointment: appointmentId
            }
            
            // Add code only if provided (for non-authenticated flow)
            if (code) {
                payload.code = code;
            }
            
            const res = await Axios.post("auth/create-google-event", payload)
            setAppointmentAdded(true)
            setSuccessMessage("Cita agregada al calendario de Google con éxito")
          
        } catch (error) {
            console.log(error)
            setErrorMessage("Hay un problema al agregar el evento a su calendario. Inténtelo de nuevo más tarde.")
        } finally {
            setAccesssToken("")
        }
    }

    const updateGoogleEvent = async (code = null) => {
        try {
            const payload = {
                title: `Appointment with Dr ${appointment?.doctorFullName}`,
                start_date: mergeDateTime(updatedData?.appDate, updatedData?.appTime),
                end_date: addMinutes(mergeDateTime(updatedData?.appDate, updatedData?.appTime), 30),
                idAppointment: appointment?.appointmentID,
                eventId: appointment?.eventId
            }
            
            // Add code only if provided (for non-authenticated flow)
            if (code) {
                payload.code = code;
            }
            
            const res = await Axios.post("auth/update-google-event", payload)
            setAppointmentAdded(true)
            setSuccessMessage(res?.data?.message || "Cita actualizada en el calendario de Google con éxito")
          
        } catch (error) {
            console.log(error)
            setErrorMessage("Hay un problema al actualizar el evento en su calendario. Inténtelo de nuevo más tarde.")
        } finally {
            setAccesssToken("")
        }
    }

    const addEvent = async (triggerSource = 'manual') => {
        if (appointmentAdded || isLoading) return;
        setIsLoading(true);
        try {
            // Use stored auth status if available; otherwise fetch once
            let authed = isWebAuthed;
            if (authed === null) {
                try {
                    const statusResp = await Axios.get("auth/google/status");
                    authed = statusResp?.data?.web === true;
                    setIsWebAuthed(authed);
                } catch (e) {
                    console.log("Error checking auth status on demand:", e);
                    authed = false;
                }
            }
            
            // Determine if this is an update context (when we have updatedData and appointment)
            const isUpdateContext = updatedData && appointment;
            
            if (authed === true) {
                // User is already authenticated, call appropriate API directly without code
                if (isUpdateContext) {
                    await updateGoogleEvent();
                } else {
                    await createGoogleEvent();
                }
                setShowPopupBlockedFallback(false);
            } else {
                // User is not authenticated, trigger login flow
                try {
                    lastLoginTriggerSourceRef.current = triggerSource;
                    login();
                } catch (oauthError) {
                    console.log("Google login trigger error:", oauthError);
                    setShowPopupBlockedFallback(true);
                }
            }
        } catch (error) {
            console.log("Error checking auth status:", error);
            // If status check fails, fall back to login flow.
            try {
                lastLoginTriggerSourceRef.current = triggerSource;
                login();
            } catch (oauthError) {
                console.log("Google login fallback trigger error:", oauthError);
                setShowPopupBlockedFallback(true);
            }
        } finally {
            setIsLoading(false);
        }
    }



    useEffect(() => {
        // Only fetch and store Google auth status on mount
        const fetchStatus = async () => {
            try {
                console.log("111");
                
                const authStatusResponse = await Axios.get("auth/google/status");
                const web = authStatusResponse?.data?.web === true;
                setIsWebAuthed(web);
                try {
                    localStorage.setItem('googleWebAuthed', JSON.stringify(web));
                } catch (_) {}
            } catch (e) {
                console.log("Error fetching google auth status", e);
                setIsWebAuthed(null);
                try {
                    localStorage.removeItem('googleWebAuthed');
                } catch (_) {}
            }
        }
        fetchStatus();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    useEffect(() => {
        if (accessToken?.length > 0) {
            setShowPopupBlockedFallback(false);
            // Determine if this is an update context
            const isUpdateContext = updatedData && appointment;
            
            if (isUpdateContext) {
                updateGoogleEvent(accessToken);
            } else {
                createGoogleEvent(accessToken);
            }
        }
    }, [accessToken])

    useEffect(() => {
        if (!autoTrigger || autoTriggeredRef.current) return;
        autoTriggeredRef.current = true;
        addEvent('auto');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [autoTrigger]);



    let classes = showUpdateCalendarBtn
        ? `inline-flex justify-center rounded-md border border-transparent ${appointmentAdded ? "bg-gray-400" : "bg-blue-600 hover:bg-blue-700"}  px-4 py-2 text-sm font-medium text-white shadow-sm  focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2`
        : `inline-flex justify-center rounded-full border border-transparent  ${appointmentAdded ? "bg-gray-500" : "bg-sky-400 hover:bg-sky-500"} px-4 py-2 text-sm font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2`
    return (
        <>

            {!autoTrigger && !showUpdateCalendarBtn && !(updatedData && appointment)
                ?
                <button
                    type="button"
                    className={classes}
                    onClick={() => addEvent()}
                    disabled={appointmentAdded}
                >
                    {appointmentAdded 
                        ? (updatedData && appointment ? "Cita actualizada en Google Calendar" : "Cita agregada a Google Calendar")
                        : (updatedData && appointment ? "" : "Agregar cita al calendario de Google")
                    }
                </button>
                : null
            }
            {showPopupBlockedFallback ? (
                <div className="mt-3 text-center">
                    <p className="text-sm text-gray-600 mb-2">Popup blocked? Click to continue.</p>
                    <button
                        type="button"
                        className="inline-flex justify-center rounded-full border border-transparent bg-sky-400 hover:bg-sky-500 px-4 py-2 text-sm font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2"
                        onClick={() => addEvent('manual')}
                        disabled={appointmentAdded || isLoading}
                    >
                        Continue with Google
                    </button>
                </div>
            ) : null}
           

        </>
    );
};

export default AddEventToCalendar;
